<template>
  <div class="accordion__fullscreen--item" :class="{ expanded: isActive, collapsed: !isActive }">
    <a class="accordion__headline" v-if="!isActive" @click.prevent="activate">
      <slot name="headline"></slot>
    </a>
    <div class="accordion__content" v-if="isActive">
      <el-container direction="vertical" class="page--container">
        <section class="page--section">
          <slot></slot>
        </section>
      </el-container>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FullScreenAccordionItem',
    props: [
      'activeItem',
      'name'
    ],
    inject: ['fullScreenAccordion'],
    computed: {
      isActive() { return this.fullScreenAccordion.activeItem === this.name; }
    },
    methods: {
      activate() { this.fullScreenAccordion.bus.$emit('fullScreenAccordionClick', this.name); }
    }
  }
</script>

<style lang="scss" scoped>

  .page {

    &--container {
      margin: 0 40px !important;
      min-height: 100.1%; // For iOS <=10.3 for scrolling after expanding content within the accordion item.
    }
  }

</style>
